import React from 'react';
import { AuthorisationOrder } from 'types';
import { Link } from 'carbon-components-react';
import { Add16 } from '@carbon/icons-react';
import { toLocalDateFormat, isAfterTodayDate } from 'utilities/helper.util';
type Props = {
  onAddOrder: (authorisationId: number) => void;
  orders: AuthorisationOrder[];
  authorisationId: number;
};
const OrderTable: React.FC<Props> = ({
  onAddOrder,
  orders,
  authorisationId
}) => {
  return (
    <div className="authorisation-orders">
      <div className="authorisation-orders-header">
        <div className="authorisation-orders-header-title">Order history</div>
        <Link onClick={() => onAddOrder(authorisationId)}>
          Add order <Add16 />
        </Link>
      </div>
      <table className="authorisation-orders-table">
        <thead>
          <tr>
            <th>Order date</th>
            <th>Reference</th>
            <th>Transactions</th>
            <th>End date</th>
            <th>Notes</th>
            <th>BYDA allowance</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order: AuthorisationOrder, i: number) => (
            <tr key={i}>
              <td>{toLocalDateFormat(order.createdAt)}</td>
              <td className="all-word">Ref. {order.reference}</td>
              <td>
                Used{' '}
                {order.amount - Number(order.transactionCount) <= 0
                  ? `all ${order.amount}`
                  : `${order.transactionCount}/${order.amount}`}
              </td>
              <td>
                {!isAfterTodayDate(order.expiredAt) ? 'Expired ' : 'Expires'}{' '}
                {toLocalDateFormat(order.expiredAt)}
              </td>
              <td className="all-word">{order.note}</td>
              <td>{order.isMembershipAllowance ? 'Yes' : 'No'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default OrderTable;
